// extracted by mini-css-extract-plugin
module.exports = {"container":"markdown-youtube-player_container__JNB6d","iframe":"markdown-youtube-player_iframe__EU8IE"};